import * as Dialog from "@radix-ui/react-dialog";
import Button from "./button";

interface DeleteConfirmationModalProps {
	open: boolean;
	title?: string;
	description?: string;
	confirmText?: string;
	cancelText?: string;
	isLoading?: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
}

export function DeleteConfirmationModal({
	open,
	title = "Delete Item",
	description = "Are you sure you want to delete this item? This action cannot be undone.",
	confirmText = "Delete",
	cancelText = "Cancel",
	isLoading = false,
	onOpenChange,
	onConfirm,
}: DeleteConfirmationModalProps) {
	return (
		<Dialog.Root open={open} onOpenChange={onOpenChange}>
			<Dialog.Portal>
				<Dialog.Overlay className="fixed inset-0 bg-black/50 z-50 modal-overlay" />
				<Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-xl z-50 w-full max-w-sm p-6 modal-content">
					<div className="flex flex-col items-center text-center">
						<div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mb-4">
							<svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
								/>
							</svg>
						</div>
						<Dialog.Title className="text-lg font-semibold text-gray-900 mb-2">{title}</Dialog.Title>
						<Dialog.Description className="text-sm text-gray-500 mb-6">{description}</Dialog.Description>
					</div>

					<div className="flex gap-3">
						<Dialog.Close asChild>
							<Button type="button" variant="soft" className="flex-1" disabled={isLoading}>
								{cancelText}
							</Button>
						</Dialog.Close>
						<button
							type="button"
							onClick={onConfirm}
							className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
							disabled={isLoading}
						>
							{isLoading ? "Deleting..." : confirmText}
						</button>
					</div>

					<Dialog.Close asChild>
						<button className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close">
							<svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
							</svg>
						</button>
					</Dialog.Close>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
}
